import api from '../config/api'

const base = '/api/v1/move/production'

async function request (method, url, data, config = {}) {
  const response = await api({ method, url, data, ...config })
  return response.data
}

export const productionApi = {
  me () {
    return request('get', `${base}/me`)
  },
  dashboard () {
    return request('get', `${base}/dashboard`)
  },
  listProjects (params = {}) {
    return request('get', `${base}/projects`, null, { params })
  },
  createProject (payload) {
    return request('post', `${base}/projects`, payload)
  },
  showProject (id) {
    return request('get', `${base}/projects/${id}`)
  },
  updateProject (id, payload) {
    return request('put', `${base}/projects/${id}`, payload)
  },
  deleteProject (id) {
    return request('delete', `${base}/projects/${id}`)
  },
  listProductions (params = {}) {
    return request('get', `${base}/productions`, null, { params })
  },
  createProduction (payload) {
    return request('post', `${base}/productions`, payload)
  },
  showProduction (id) {
    return request('get', `${base}/productions/${id}`)
  },
  updateProduction (id, payload) {
    return request('put', `${base}/productions/${id}`, payload)
  },
  deleteProduction (id) {
    return request('delete', `${base}/productions/${id}`)
  },
  async uploadScript (id, file) {
    const form = new FormData()
    form.append('file', file)
    const response = await api.post(`${base}/productions/${id}/script-file`, form, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    return response.data
  },
  deleteScript (id) {
    return request('delete', `${base}/productions/${id}/script-file`)
  },
  listMembers (productionId) {
    return request('get', `${base}/productions/${productionId}/members`)
  },
  addMember (productionId, payload) {
    return request('post', `${base}/productions/${productionId}/members`, payload)
  },
  updateMember (productionId, memberId, payload) {
    return request('put', `${base}/productions/${productionId}/members/${memberId}`, payload)
  },
  deleteMember (productionId, memberId) {
    return request('delete', `${base}/productions/${productionId}/members/${memberId}`)
  },
  listComments (productionId) {
    return request('get', `${base}/productions/${productionId}/comments`)
  },
  addComment (productionId, content) {
    return request('post', `${base}/productions/${productionId}/comments`, { content })
  },
  deleteComment (commentId) {
    return request('delete', `${base}/comments/${commentId}`)
  },
  analytics (productionId) {
    return request('get', `${base}/productions/${productionId}/analytics`)
  },
  createSnapshot (productionId, payload) {
    return request('post', `${base}/productions/${productionId}/analytics`, payload)
  },
  updateSnapshot (productionId, snapshotId, payload) {
    return request('put', `${base}/productions/${productionId}/analytics/${snapshotId}`, payload)
  },
  deleteSnapshot (productionId, snapshotId) {
    return request('delete', `${base}/productions/${productionId}/analytics/${snapshotId}`)
  },
  listScenes (productionId) {
    return request('get', `${base}/productions/${productionId}/scenes`)
  },
  createScene (productionId, payload) {
    return request('post', `${base}/productions/${productionId}/scenes`, payload)
  },
  updateScene (productionId, sceneId, payload) {
    return request('put', `${base}/productions/${productionId}/scenes/${sceneId}`, payload)
  },
  deleteScene (productionId, sceneId) {
    return request('delete', `${base}/productions/${productionId}/scenes/${sceneId}`)
  },
  reorderScenes (productionId, ids) {
    return request('put', `${base}/productions/${productionId}/scenes/reorder`, { ids })
  },
  listMoodBoard (productionId) {
    return request('get', `${base}/productions/${productionId}/mood-board`)
  },
  async addMoodBoardItem (productionId, payload) {
    const form = new FormData()
    if (payload.file) form.append('file', payload.file)
    if (payload.image_url) form.append('image_url', payload.image_url)
    if (payload.caption) form.append('caption', payload.caption)
    if (payload.source_url) form.append('source_url', payload.source_url)
    if (payload.production_scene_id) form.append('production_scene_id', payload.production_scene_id)
    const response = await api.post(`${base}/productions/${productionId}/mood-board`, form, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    return response.data
  },
  updateMoodBoardItem (productionId, itemId, payload) {
    return request('put', `${base}/productions/${productionId}/mood-board/${itemId}`, payload)
  },
  deleteMoodBoardItem (productionId, itemId) {
    return request('delete', `${base}/productions/${productionId}/mood-board/${itemId}`)
  },
  presenterCandidates (search = '') {
    return request('get', `${base}/presenter-candidates`, null, { params: { search } })
  },
  assignableTeam () {
    return request('get', `${base}/team/assignable`)
  },
  listTeam () {
    return request('get', `${base}/team`)
  },
  inviteTeam (payload) {
    return request('post', `${base}/team`, payload)
  },
  updateTeam (id, payload) {
    return request('put', `${base}/team/${id}`, payload)
  },
  removeTeam (id) {
    return request('delete', `${base}/team/${id}`)
  }
}

export default productionApi
